import React, { Component } from "react";
import SwaggerUI from 'swagger-ui-react';
import "swagger-ui-react/swagger-ui.css";

class Swagger extends Component {

    render() {
        return (
            <SwaggerUI url="/api/external/docs/openapi.json" />
        );
    }

}

export default Swagger;
